import React from "react";
import ReactDOM from "react-dom/client";
import "@/utils/csrf";
import "@/index.css";
import "@/i18n";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Audit fix 11.1 — register the app-shell service worker in production only.
// Defer to `load` so we never contend with the LCP paint on mobile 4G.
if (
  'serviceWorker' in navigator &&
  process.env.NODE_ENV === 'production' &&
  typeof window !== 'undefined'
) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .catch(() => {
        /* silent — PWA is best-effort; app still works without it */
      });
  });
}
